import ko from "knockout";
import * as _ from "underscore";
import FilterButtonHelper, { IFilter } from "flow/filter/filterButtonHelper";

export interface IFilterContainerViewContext {
    filters: KnockoutObservableArray<IFilter>;
    filterHandle: KnockoutObservable<IFilterHandle>;
    recordsCount: any;
    filterCriteria: any;
}

export interface IFilterHandle {
    collapse: () => void;
    expand: () => void;
    clearAllFilters: () => void;
}

const FilterContainerViewModel = function (params: IFilterContainerViewContext) {
    const filterVisible = ko.observable(false);
    const filterButtonHelper = new FilterButtonHelper(params.filters);
    const filterSelected = ko.computed(function () {
        return filterButtonHelper.selectedFilters().length > 0;
    });

    const toggleFilterVisibility = function () {
        filterVisible(!filterVisible());
    };

    const collapse = function () {
        filterVisible(false);
    };

    const expand = function () {
        filterVisible(true);
    };

    const clearAllFilters = function () {
        filterButtonHelper.clearAllFilters();
    };

    if (params.filterHandle) {
        params.filterHandle({
            collapse: collapse,
            expand: expand,
            clearAllFilters: clearAllFilters
        });
    }

    return {
        recordsCount: params.recordsCount,
        filterCriteria: params.filterCriteria,
        filterSelected: filterSelected,
        toggleFilterVisibility: toggleFilterVisibility,
        filterVisible: filterVisible,
        filterButtonHelper: filterButtonHelper
    };
};

export default FilterContainerViewModel;
